import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Configuration } from "../core/configuration";
import { ConfigurationLoader } from "../core/services/configuration-loader.service";

@Component({
    selector: "serprobots-header",
    templateUrl: "header.component.html",
    styleUrls: ["header.component.css"]
})
export class HeaderComponent implements OnInit {
    configuration: Configuration = new Configuration({});

    @Output()
    onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    onMinimize: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private configurationLoader: ConfigurationLoader
    ) {}

    async ngOnInit(): Promise<void> {
        this.configuration = await this.configurationLoader.getConfiguration();
    }

    close(): void {
        this.onClose.emit(true);
    }

    minimize(): void {
        this.onMinimize.emit(true);
    }

   /**
     * Disponibiliza para o Template qual a classe de tipografia que deve ser usada.
     * 
     * @returns Classe de Tipografia.
     */
    getTypographyClass(): string {
        return `${this.configuration.typography || ""} mat-typography`;
    }    
}